<template>
  <input
      type="text"
      class="timepicker"
      :placeholder="placeholderText()"
      @input="handleInput"
      @keyup="handleKeyUp"
  >
</template>

<script>
export default {
  name: 'TimePickerComponent',
  props: {
    value: {
      type: String,
      default: ''
    },
    required: {
      type: Boolean,
      default: false
    },
    format24h: {
      type: Boolean,
      default: undefined
    },
    unlimitedHours: {
      type: Boolean,
      default: undefined
    },
    addSeconds: {
      type: Boolean,
      default: true
    },
    maxTime: {
      type: Array,
      default: null
    },
    placeholder: {
      type: String,
      default: undefined
    }
  },
  data() {
    return {
      content: this.value
    }
  },
  mounted() {
    $(this.$el).timeEntry({
      show24Hours: this.show24Hours(),
      unlimitedHours: this.hasUnlimitedHours(),
      showSeconds: false,
      ampmPrefix: ' ',
      spinnerImage: '',
      defaultTime: new Date(0, 0, 0, 9, 0, 0),
      maxTime: this.maxTime
    });

    this.$el.value = this.value;
    if (this.value && !this.isAbove24Hours(this.value)) {
      $(this.$el).timeEntry('setTime', this.value);
    }
  },
  watch: {
      value: function(newVal, oldVal) {
        if (newVal && !this.isAbove24Hours(newVal)) {
          this.content = this.$moment(newVal, "hh:mm a").format(this.valueFormat());
          const format = this.show24Hours() ? "HH:mm" : "hh:mm A";
          this.$el.value = this.$moment(this.content, this.valueFormat()).format(format);
        } else {
          this.$el.value = newVal;
        }
      }
  },
  methods: {
    show24Hours() {
      return this.format24h !== undefined ? this.format24h
          : !this.$store.state.userSettings.is_am_pm_time_format;
    },
    hasUnlimitedHours() {
      return this.unlimitedHours !== undefined ? this.unlimitedHours : false;
    },
    valueFormat() {
      return this.addSeconds !== undefined && this.addSeconds ? 'HH:mm:ss' : 'HH:mm';
    },
    placeholderText() {
      if (this.placeholder !== undefined) {
        return this.placeholder;
      }
      if (this.show24Hours()) {
        return 'hh:mm';
      }
      return 'h:mm a';
    },
    handleInput(e) {
      this.content = e.target.value;
      if (e.target.value != null && e.target.value !== "") {
        this.fillContent(e.target.value);
      }
      this.$emit('input', this.content);
    },
    handleKeyUp(e) {
      const oldValue = this.content;
      this.content = e.target.value;
      if (e.target.value != null && e.target.value !== "") {
        this.fillContent(e.target.value);
      }
      this.$emit('input', this.content);
      if (this.required && this.content === '' && oldValue !== '') {
        this.$emit('input', oldValue);
        this.$el.value = oldValue;
      }
    },
    fillContent(value) {
      if (!this.isAbove24Hours(value)) {
        this.content = this.$moment(value, "hh:mm a").format(this.valueFormat());
        const format = this.show24Hours() ? "HH:mm" : "hh:mm A";
        this.$el.value = this.$moment(this.content, this.valueFormat()).format(format);
      } else {
        this.content = value + (this.addSeconds ? ':00' : '');
      }
    },
    isAbove24Hours(value) {
      const time = value.split(':');
      return time.length > 0 && parseInt(time[0]) >= 24;
    }
  }
}
</script>

<style lang="scss">

.timepicker::placeholder {
  outline-color: red;
}

input.timepicker {
  border: 2px solid #EFEFEF;
  padding: 8px;
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-family: "Roboto", sans-serif;
  font-weight: 400;
  color: $atto-font-color;

  @include style-placeholder(#999)
}
</style>